import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

import { CommonInputControlDirective } from 'app/shared/directives/control/common-input-control.directive';
import { InputTypes } from 'app/shared/enums/input-types.enum';

@Component({
  selector: 'kh-change-password-input',
  templateUrl: './change-password-input.component.html',
  styleUrls: ['./change-password-input.component.less'],
  standalone: false
})
export class ChangePasswordInputComponent {
  @ViewChild('passwordInput', { static: false })
  public passwordInput!: CommonInputControlDirective;

  public FORM_FIELDS = {
    newPassword: 'newPassword'
  };

  public passwordGroup = new FormGroup({
    newPassword: new FormControl()
  });

  public inputTypes = InputTypes;
  public markAsError = false;
  public showRequired = false;
  public requiredMessage = '';

  public getPasswordFormControl(): AbstractControl {
    return this.passwordGroup.controls.newPassword;
  }

  public getInputSoFar(): string {
    return (this.passwordInput && this.passwordInput.model) ? this.passwordInput.model : '';
  }
}
